module.exports = __webpack_public_path__ + "static/media/job.ba60dbfc.avif";